/* 🤖 this file was generated by svg-to-ts */
export const DfIconPersonPlus16: {
  name: 'person-plus-16';
  data: string;
} = {
  name: 'person-plus-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.75 11.75v1.5a.75.75 0 1 1-1.5 0v-1.5h-1.5a.75.75 0 1 1 0-1.5h1.5v-1.5a.75.75 0 1 1 1.5 0v1.5h1.5a.75.75 0 1 1 0 1.5zM12 15.958C10.778 16 9.39 16 8 16c-4 0-8 0-8-1 0-5 6-1.602 6-5 0-2.004-1.5-2.996-1.5-5S5.129 0 8 0s3.5 2.999 3.5 5c0 .484-.088.909-.22 1.304A5.002 5.002 0 0 0 12 15.9v.058z"/></svg>`
};
